import { Component, OnInit } from '@angular/core';
import {ApiService, SignInResult} from '../../api/api.service';
import {LayoutManagerService} from '../../layout-manager.service';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {CookieService} from 'ngx-cookie-service';
import {ActivatedRoute} from '@angular/router';
import { ErrorStateMatcher } from '@angular/material/core';

@Component({
  selector: 'app-affiliate-program-content',
  templateUrl: './affiliate-program-content.component.html',
  styleUrls: ['./affiliate-program-content.component.css']
})
export class AffiliateProgramContentComponent implements OnInit {

  formGroup: FormGroup;
  matcher = new LoginStateMatcher(this);
  signInResponse: SignInResult;
  partner = true;
  loading = false;
  affiliato=false;
  affEmail: string = '';
  signedIn = false

  constructor(
    private formBuilder: FormBuilder,
    private api: ApiService,
    public layoutManager: LayoutManagerService,
    private cookieService: CookieService,
    private activatedRoute: ActivatedRoute
  ) {
    this.formGroup = formBuilder.group({
      name: [Validators.required],
      surname: [Validators.required],
      email: [Validators.required, Validators.email],
      password: [Validators.required, Validators.minLength(7)],
      password_check: [Validators.required, Validators.minLength(7)],
      fisc_code: [Validators.required, Validators.pattern('^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$')],
      indirizzo: [Validators.required],
      civico: [Validators.required],
      citta: [Validators.required],
      cap: [Validators.required, Validators.pattern('\\d{5}')]
    });
    this.formGroup.controls.name.setValue('');
    this.formGroup.controls.surname.setValue('');
    this.formGroup.controls.email.setValue('');
    this.formGroup.controls.password.setValue('');
    this.formGroup.controls.password_check.setValue('');
    this.formGroup.controls.fisc_code.setValue('');
    this.formGroup.controls.indirizzo.setValue('');
    this.formGroup.controls.civico.setValue('');
    this.formGroup.controls.citta.setValue('');
    this.formGroup.controls.cap.setValue('');
  }

  ngOnInit() {
    window.scroll(0,0)
    if(this.activatedRoute.snapshot.paramMap.get("aff")!= undefined && this.activatedRoute.snapshot.paramMap.get("aff")!= '') {
      const expiredDate = new Date();
      expiredDate.setDate( expiredDate.getDate() + 365 );
      this.cookieService.set('affiliate', this.activatedRoute.snapshot.paramMap.get("aff"), expiredDate);
      console.log('path aff')
    }
    if(this.cookieService.get('affiliate')!= undefined && this.cookieService.get('affiliate') != '') {
      this.affiliato = true;
      this.affEmail = btoa(this.cookieService.get('affiliate'));
      console.log(this.affEmail);
    }
  }

  signInClick() {
    let valid = this.formGroup.get('password').value === this.formGroup.get('password_check').value;
    valid = valid && this.formGroup.valid;
    console.log(valid)
    if (valid) {
      this.loading = true;
      this.api.signIn(this.formGroup.controls.name.value +' '+ this.formGroup.controls.surname.value, btoa(this.formGroup.controls.email.value),
        btoa(this.formGroup.controls.password.value),
        btoa(this.formGroup.controls.indirizzo.value), btoa(this.formGroup.controls.civico.value),
        btoa(this.formGroup.controls.citta.value), btoa(this.formGroup.controls.cap.value),
        btoa(this.formGroup.controls.fisc_code.value),
        this.partner, false, this.affEmail).subscribe(response => {
        this.signedIn = true;
        this.loading = false;
        this.signInResponse = response;
      })

    }
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }
}

/** Error when invalid control is dirty, touched, or submitted. */
export class LoginStateMatcher implements ErrorStateMatcher {

  constructor(private parentClass) {

  }

  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const samePassword = this.parentClass.formGroup.get('password').value !== this.parentClass.formGroup.get('password_check').value;
    return !!(control && control.invalid
      && (control.dirty || control.touched)) || samePassword;
  }
}
